import './champion-card.css'
import { useLanguage } from '../../i18n/LanguageContext'

export default function ChampionItems({ items, itemComponents, itemImageMap }) {
  const { t } = useLanguage()
  if (!items.length) return null

  return (
    <div className="champion-card__items">
      {items.map((item, i) => {
        const icon = itemImageMap?.[item.name]
        const components = itemComponents?.[item.name] ?? []
        return (
          <div key={i} className="item-wrapper">
            {icon ? (
              <img
                src={icon}
                alt={item.name}
                title={item.name}
                className="champion-card__item-image"
              />
            ) : (
              <span className="champion-card__item-text">{item.name}</span>
            )}
            {components.length > 0 && (
              <div className="item-tooltip">
                <span className="item-tooltip__label">{t('item.recipe')}</span>
                <div className="item-tooltip__components">
                  {components.map((comp, j) => {
                    const compIcon = itemImageMap?.[comp]
                    return compIcon ? (
                      <img
                        key={j}
                        src={compIcon}
                        alt={comp}
                        title={comp}
                        className="item-tooltip__icon"
                      />
                    ) : (
                      <span key={j} className="item-tooltip__component">
                        {comp}
                      </span>
                    )
                  })}
                </div>
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}
